<template>
  <deals-view :filters="{ featured: true }"></deals-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import DealsView from "@/client/applications/justopp/views/Deals.vue";

export default {
  components: {
    DealsView,
  },
  layout: {
    component: "default",
    params: {
      title: "justopp.hotDeals.pageTitle",
      subTitle: "justopp.hotDeals.pageSubtitle",
    },
  },
  middleware: {},
  props: {},
  setup() {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "justopp.hotDeals.browserTitle",
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
